<template>
  <div class="dialog-content pl-3 pt-3" v-if="this.currentQuotation != null">
    <v-row class="dialog-body">
      <div>
        <table style="min-width: 100%; font-size: 12px">
          <tr>
            <td>
              <table
                style="
                  text-align: center;
                  min-width: 100%;
                  font-size: 12px;
                  min-height: 55px;
                  border-collapse: collapse;
                "
              >
                <tr
                  style="
                    background-color: #f2f2f2;
                    font-weight: bold;
                    min-width: 100%;
                  "
                >
                  <td style="width: 33%; text-align: left;">
                    <span>
                      <img loading="lazy"
                        style="max-width: 30%; margin-left: 10px"
                        src="@/assets/Tagline_todo preto.png"
                      />
                    </span>
                  </td>
                  <td style="width: 33%">
                    <span style="text-align: center; font-size: 18px"
                      >Lockton Brasil</span
                    ><br />
                    <span style="text-align: center; font-size: 16px"
                      >Cotação de Seguro Agrícola</span
                    ><br />
                    <span style="text-align: center; font-size: 14px"
                      >Proteção e Segurança para o Produtor Rural</span
                    >
                  </td>
                  <td style="width: 33%; text-align: right">
                    <span
                      ><img loading="lazy"
                        style="max-width: 30%; margin-right: 10px; max-height: 90px; margin-top: 6px"
                        :src="getLogoGrupoEconomico">
                    </span>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td class="section-title">
              <span style="margin-left: 5px">DADOS DO PROPONENTE</span>
            </td>
          </tr>
          <tr>
            <td>
              <table class="dados-proponente-table">
                <tr>
                  <th colspan="2">Nome</th>
                  <th>CPF/CNPJ</th>
                  <th>Telefone</th>
                  <th>Município do Risco</th>
                  <th>UF</th>
                </tr>
                <tr>
                  <td colspan="2">
                    {{ this.currentQuotation.segurado.nome }}
                  </td>
                  <td>
                    {{ this.currentQuotation.segurado.numero_documento }}
                  </td>
                  <td>
                    {{ this.currentQuotation.segurado.celular }}
                  </td>
                  <td>
                    {{ this.currentQuotation.area_risco.cidade }}
                  </td>
                  <td>
                    {{ this.currentQuotation.area_risco.uf.id }}
                  </td>
                </tr>
                <tr>
                  <th>Cultura</th>
                  <th>Tecnica de Plantio</th>
                  <th>Tipo de solo</th>
                  <th>Área do Risco (ha)</th>
                  <th colspan="2">Nome da Fazenda (Área)</th>
                </tr>
                <tr
                  v-for="(item, index) in currentQuotation.itens_agricola"
                  :key="item.id"
                >
                  <td>
                    {{ currentQuotation.submodalidade.nome }}
                  </td>
                  <td>
                    {{ item.tecnica_plantio.name }}
                  </td>
                  <td>
                    {{ item.classificacao_solo.nome }}
                  </td>
                  <td>
                    {{ item.area_plantada }}
                  </td>
                  <td colspan="2">
                    {{ "Área " + (index + 1) + " - " + item.nome }}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr v-if="haveProductivity && this.isTableView">
            <td class="section-title">
              <span style="margin-left: 5px">
                DADOS DA COTAÇÃO - SEGURO AGRÍCOLA PRODUTIVIDADE
              </span>
            </td>
          </tr>
          <tr v-if="haveProductivity && this.isTableView">
            <td>
              <table class="seguro-agricola-table">
                <tr>
                  <th>
                    Id
                  </th>
                  <th>
                    Seguradora
                  </th>
                  <th>
                    Área Segurada (ha)
                  </th>
                  <th>
                    Regulação Sinistro
                  </th>
                  <th>
                    Coberturas
                  </th>
                  <th>
                    Importância Segurada
                  </th>
                  <th>
                    Prod. Garantida (sc/ha)
                  </th>
                  <th>
                    Custo por Saca
                  </th>
                  <th>
                    Preço Total
                  </th>
                  <th>
                    Subvenção Federal
                  </th>
                  <th>
                    Preço do Segurado
                  </th>
                  <th>
                    Preço Produtor (sc/ha)
                  </th>
                  <th>
                    Forma de Pagamento
                  </th>
                </tr>
                <tr v-for="item in filterCostsProdutividade()" :key="item.id">
                  <td>
                    {{ "1." + (filterCostsProdutividade().indexOf(item) + 1) }}
                  </td>
                  <td>{{ item.seguradora.nome }}</td>
                  <td>{{ item.area_segurada }}</td>
                  <td>{{ item.tipo_reivindicacao.name }}</td>
                  <td>{{ item.tipo_cobertura.name }}</td>
                  <td>R$ {{ asNumberString(item.importancia_segurada) }}</td>
                  <td>{{ item.producao_garantida }}</td>
                  <td>R$ {{ asNumberString(item.custo_por_saca) }}</td>
                  <td>R$ {{ asNumberString(item.custo_total) }}</td>
                  <td v-if="item.subvencao_federal != null">
                    R$ {{ asNumberString(item.subvencao_federal) }}
                  </td>
                  <td>R$ {{ asNumberString(item.custo_segurado) }}</td>
                  <td>R$ {{ asNumberString(item.custo_produtor) }}</td>
                  <td>{{ getParcelas(item) }}</td>
                </tr>
              </table>
            </td>
          </tr>
          <table
            v-if="haveProductivity && !this.isTableView"
            style="margin-top: 20px;"
          >
            <tr>
              <td>
                <tr>
                  <td class="section-title titleCard">
                    <span style="padding: 5px; width: auto">
                      DADOS DA COTAÇÃO - SEGURO AGRÍCOLA PRODUTIVIDADE
                    </span>
                  </td>
                </tr>
                <tr class="cards-containerAgricola mt-3">
                  <td
                    class="container-cardsAgricola ml-5"
                    v-for="item in filterCostsProdutividade()"
                    :key="item.id"
                  >
                    <QuotationCostsCardAgricolaProdutividade
                      ref="cardProdutividade"
                      :item="item"
                      class="card-wrapperAgricola"
                      :showButton="false"
                    />
                  </td>
                </tr>
              </td>
            </tr>
          </table>
          <tr v-if="haveProductivity">
            <br />
          </tr>
          <table style="page-break-inside: avoid;">
            <tr>
              <td>
                <tr v-if="haveCosting">
                  <td class="section-title titleCard">
                    <span style="padding: 5px;">
                      DADOS DA COTAÇÃO - SEGURO AGRÍCOLA CUSTEIO
                    </span>
                  </td>
                </tr>
                <tr v-if="haveCosting && this.isTableView">
                  <td>
                    <table class="seguro-agricola-table">
                      <tr>
                        <td>
                          Id
                        </td>
                        <td>
                          Seguradora
                        </td>
                        <td>
                          Área Segurada (ha)
                        </td>
                        <td>
                          Regulação Sinistro
                        </td>
                        <td>
                          Coberturas
                        </td>
                        <td>
                          Importância segurada
                        </td>
                        <td>
                          Prod. Garantida (sc/ha)
                        </td>
                        <td>
                          Custo por Hectare
                        </td>
                        <td>
                          Preço Total
                        </td>
                        <td>
                          Subvenção Federal
                        </td>
                        <td>
                          Preço do Segurado
                        </td>
                        <td>
                          Preço Produtor (sc/ha)
                        </td>
                        <td>
                          Forma de Pagamento
                        </td>
                      </tr>
                      <tr v-for="item in filterCostsCusteio()" :key="item.id">
                        <td>{{ "1." + (filterCostsCusteio().indexOf(item) + 1) }}</td>
                        <td>{{ item.seguradora.nome }}</td>
                        <td>{{ item.area_segurada }}</td>
                        <td>{{ item.tipo_reivindicacao.name }}</td>
                        <td>{{ item.tipo_cobertura.name }}</td>
                        <td>R$ {{ asNumberString(item.importancia_segurada) }}</td>
                        <td>{{ item.producao_garantida }}</td>
                        <td>R$ {{ asNumberString(item.custo_por_hectare) }}</td>
                        <td>R$ {{ asNumberString(item.custo_total) }}</td>
                        <td v-if="item.subvencao_federal != null">
                          R$ {{ asNumberString(item.subvencao_federal) }}
                        </td>
                        <td>R$ {{ asNumberString(item.custo_segurado) }}</td>
                        <td>R$ {{ asNumberString(item.custo_produtor) }}</td>
                        <td>{{ getParcelas(item) }}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr
                  v-if="haveCosting && !this.isTableView"
                  class="cards-containerAgricola mt-3"
                >
                  <td
                    class="container-cardsAgricola ml-5"
                    v-for="item in filterCostsCusteio()"
                    :key="item.id"
                  >
                    <QuotationCostsCardAgricolaCusteio
                      ref="cardCusteio"
                      :item="item"
                      class="card-wrapperAgricola"
                      :showButton="false"
                    />
                  </td>
                </tr>
              </td>
            </tr>
          </table>
          <tr v-if="haveCosting">
            <br />
          </tr>
          <tr>
            <td style="page-break-inside: avoid">
              <table
                style="
                  font-size: 12px;
                  min-width: 100%;
                  border-collapse: collapse;
                  border: 1px solid black;
                "
              >
                <tr>
                  <td class="section-title">
                    <span style="margin-left: 5px;">
                      DETALHE DAS COBERTURAS
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span style="color: #c00000; font-weight: bold"
                      >Cobertura Básica:
                    </span>
                    Contempla os seguintes riscos: Granizo, Seca, Geada,
                    Vendaval/Ventos Fortes, Tromba D´água, Chuva Excessiva,
                    Inundação/Alagamento, Variação Excessiva <br />
                    de Temperatura, Raio e Incêndio
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr>
            <td>
              <table
                style="
                  font-size: 12px;
                  min-width: 100%;
                  border-collapse: collapse;
                  border: 1px solid black;
                "
              >
                <tr>
                  <td class="section-title">
                    <span style="margin-left: 5px;">
                      CARÊNCIA DAS COBERTURAS
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span style="color: #c00000; font-weight: bold">
                      Cobertura Básica:
                    </span>
                    O período de carência será até que no mínimo 60% das plantas
                    atinjam uma altura a partir do nível do solo superior a 15
                    cm para Algodão, Girassol, Milho, Feijão e Soja e altura
                    superior a 10 cm para Trigo, Canola e Cevada. Caso a cultura
                    esteja plantada, a carência será de 24 horas apartir do
                    início de vigência da apólice, sempre que no mínimo 60% das
                    plantas atinjam uma altura a partir do nível do solo
                    superior a 15 cm para Algodão, Girassol, Milho, Feijão e
                    Soja e altura superior a 10 cm para Trigo, Canola e Cevada.
                    <br />
                    <span style="color: #c00000; font-weight: bold">
                      Cobertura Adicional:
                    </span>
                    Inicio de Vigência da Cobertura: 7 (sete) dias após a
                    semeadura, ou quando 60% da área total contratada estiver
                    emergida, e termina com início da cobertura básica e/ou
                    Prazo Final de Plantio do Zoneamento Agrícola do MAPA, para
                    a cultura segurada.
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr>
            <td>
              <table
                style="
                  font-size: 12px;
                  min-width: 100%;
                  border-collapse: collapse;
                  border: 1px solid black;
                "
              >
                <tr>
                  <td class="section-title">
                    <span style="margin-left: 5px;">
                      FORMA DE REGULAÇÃO DO SINISTRO
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span style="color: #c00000; font-weight: bold">
                      Média da Área Total:
                    </span>
                    Em caso de sinistro a regulação será pela média da área
                    total, ou seja, o cálculo de indenização será efetuado com
                    base na produtvidade média de toda a área segurada.
                    <br />
                    <span style="color: #c00000; font-weight: bold">
                      Regulação por Talhão/Item:
                    </span>
                    A Seguradora Newe apresentou condições com regulação por
                    talhão com área mínima de 30 hectares. Os talhões/itens
                    precisam apresentar entre eles separação física por estrada,
                    rodovia, matas/florestas, outras culturas, lago ou rio.
                    Estradas internas e carreadores NÃO serão consideradas
                    suficientes para separação física de itens. Na Seguradora
                    Sompo os talhões serão divididos conforme croqui
                    apresentado.
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr v-if="this.currentQuotation.itens_agricola.length > 0">
            <td>
              <table
                style="
                  font-size: 12px;
                  min-width: 100%;
                  border-collapse: collapse;
                  border: 1px solid black;
                "
              >
                <tr>
                  <td
                    v-html="formatText(currentQuotation.informacoes_adicionais)"
                  ></td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr>
            <td>
              <tr class="info-section-title">
                <td>
                  <span style="margin-left: 5px;">
                    INFORMAÇÕES ADICIONAIS
                  </span>
                </td>
              </tr>
              <table class="info-section-table">
                <tr>
                  <td>
                    Esta proposta de seguro poderá ser submetida ao Ministério
                    da Agricultura, Pecuária e Abastecimento - MAPA para
                    verificação quanto à concessão de subvenção ao prêmio de
                    seguro rural do Governo Federal, conforme os critérios
                    exigidos pelo Programa, que devem ser atendidos
                    integralmente pelo Proponente/Segurado. Caso a proposta não
                    se enquadre nas regras vigentes do programa ou o MAPA não
                    conceda, ou conceda parcialmente, o subsídio, o pagamento
                    correspondente ao valor não obtido da subvenção federal ao
                    prêmio líquido do seguro será de inteira responsabilidade do
                    Proponente/Segurado. Nesse caso, o Proponente/Segurado
                    deverá efetuar o pagamento da parcela correspondente à
                    subvenção, no vencimento previsto em boleto a ser enviado
                    pela seguradora, restando acordado desde já que o não
                    pagamento desta parcela determinará a redução da vigência da
                    apólice.
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr>
            <td>
              <tr class="info-section-title">
                <td>
                  <span style="margin-left: 5px;">SUBVENÇÃO FEDERAL</span>
                </td>
              </tr>
              <table class="info-section-table">
                <tr>
                  <td>
                    Esta proposta de seguro poderá ser submetida ao Ministério
                    da Agricultura, Pecuária e Abastecimento - MAPA para
                    verificação quanto à concessão de subvenção ao prêmio de
                    seguro rural do Governo Federal, conforme os critérios
                    exigidos pelo Programa, que devem ser atendidos
                    integralmente pelo Proponente/Segurado. Caso a proposta não
                    se enquadre nas regras vigentes do programa ou o MAPA não
                    conceda, ou conceda parcialmente, o subsídio, o pagamento
                    correspondente ao valor não obtido da subvenção federal ao
                    prêmio líquido do seguro será de inteira responsabilidade do
                    Proponente/Segurado. Nesse caso, o Proponente/Segurado
                    deverá efetuar o pagamento da parcela correspondente à
                    subvenção, no vencimento previsto em boleto a ser enviado
                    pela seguradora, restando acordado desde já que o não
                    pagamento desta parcela determinará a redução da vigência da
                    apólice.
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr>
            <td>
              <tr class="info-section-title">
                <td>
                  <span style="margin-left: 5px;">
                    SUSEP – SUPERINTENDÊNCIA DE SEGUROS PRIVADOS
                  </span>
                </td>
              </tr>
              <table class="info-section-table">
                <tr>
                  <td>
                    A SUSEP é o órgão responsável pela regulamentação e
                    fiscalização das operações das seguradoras, sujeitas às leis
                    e regulamentos no Brasil, inclusive referentes à solvência.
                    Em atendimento as disposições contidas na Resolução CNSP no
                    382/2020, a comissão de corretagem para esta colocação
                    {{ getComissao }}. Havendo interesse em obter mais
                    informações sobre alguma seguradora em particular, incluindo
                    informação sobre suas finanças e solvência, por favor,
                    consulte diretamente a SUSEP.
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <br />
          </tr>
          <tr>
            <td>
              <tr class="info-section-title">
                <td>
                  <span style="margin-left: 5px;">
                    DIVULGAÇÃO E CONFIRMAÇÃO DE INFORMAÇÕES
                  </span>
                </td>
              </tr>
              <table class="info-section-table">
                <tr>
                  <td>
                    Esta proposta foi produzida com base nas informações
                    disponibilizadas por você, e por esta razão, a Lockton não
                    assumirá qualquer responsabilidade decorrente da imprecisão
                    dos dados recebidos ou as recomendações baseadas na
                    informação fornecida. Este documento não oferece qualquer
                    recomendação legal, contábil ou tributária. Você, segurado
                    deve fornecer todas as informações relacionadas ao risco do
                    seu negócio e que possam afetar o julgamento da seguradora
                    na aceitação do risco, a determinação do prêmio do seguro,
                    as condições e cláusulas da apólice; caso as referidas
                    informações não forem divulgadas, quando da ocorrência de
                    sinistro o a Seguradora poderá anular indenizações desde o
                    início de sua vigência ou mesmo não acatar sinistros
                    ocorridos, em conformidade com o Artigo 766 do Código Civil.
                    Lembramos que este documento é confidencial e
                    terminantemente proibido sua divulgação parcial ou total a
                    terceiros sem a expressa autorização da Lockton. A Lockton
                    Brasil seguindo a política mundial do grupo, possui um
                    conjunto de princípios que compõem as bases do
                    relacionamento comercial com os nossos Clientes, definindo
                    em linhas gerais, nossos processos internos e critérios de
                    colocação de riscos e administração de seguros.
                    <a href="http://" target="_blank" rel="noopener noreferrer">
                      Para saber mais CLIQUE AQUI.
                    </a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </div>
    </v-row>
  </div>
</template>

<script>
import { asNumberString } from "@/utils/formats.js";
import QuotationCostsCardAgricolaProdutividade from "./QuotationCostsCardAgricolaProdutividade.vue";
import QuotationCostsCardAgricolaCusteio from "./QuotationCostsCardAgricolaCusteio.vue";
export default {
  name: "QuotationDocumentAgricola",
  components: {
    QuotationCostsCardAgricolaProdutividade,
    QuotationCostsCardAgricolaCusteio
  },
  data() {
    return {
      asNumberString,
      closePrint: false,
      selectedCost: null
    };
  },
  created() {
    this.setSelectedCost();
  },
  computed: {
    getLogoGrupoEconomico() {
      return (
        this.currentQuotation.grupo_economico?.logo_url ??
        this.selectedCost.grupo_economico?.logo_url
      );
    },
    haveProductivity() {
      return this.filterCostsProdutividade()?.length > 0;
    },
    haveCosting() {
      return this.filterCostsCusteio()?.length > 0;
    },
    getComissao() {
      let comissao = '';
      if (this.selectedCost) {
        comissao = `é de ${ this.selectedCost[0].comissao } porcento`;
      } else {
        comissao = "é [definida mediante escolha da cotação]";
      }
      return comissao;
    }
  },
  methods: {
    filterCostsCusteio() {
      if (
        this.selectedCost != null &&
        this.selectedCost[0]?.tipo_seguro?.id == "custeio"
      ) {
        return this.selectedCost;
      }

      if (
        this.currentQuotation.custos.length > 0 &&
        this.selectedCost == null
      ) {
        return this.currentQuotation.custos.filter(
          a => a.tipo_seguro?.id == "custeio"
        );
      }
    },
    filterCostsProdutividade() {
      if (
        this.selectedCost != null &&
        this.selectedCost[0]?.tipo_seguro?.id == "produtividade"
      ) {
        return this.selectedCost;
      }

      if (
        this.currentQuotation.custos.length > 0 &&
        this.selectedCost == null
      ) {
        return this.currentQuotation.custos.filter(
          a => a.tipo_seguro?.id == "produtividade"
        );
      }
    },
    setSelectedCost() {
      if (this.currentQuotation.custos.some(a => a.aprovada_em != null)) {
        this.selectedCost = this.currentQuotation.custos.filter(
          a => a.aprovada_em != null
        );
        this.selectedCost.grupo_economico = this.currentQuotation.grupo_economico;
      }
    },
    formatText(text) {
      if (text == null) {
        return "";
      }

      const lines = text.split("  ");
      const firstLine = `<span style="background-color: black; color: white; display: block;">${lines[0].toUpperCase()}</span>`;
      const remainingLines = lines.slice(1).filter(line => line.trim() !== "");
      const formattedText = [firstLine, ...remainingLines].join("  ");

      return formattedText;
    },
    getParcelas(item) {
      if (this.currentQuotation.forma_pagamento != null) {
        let valor =
          item.custo_segurado / this.currentQuotation.forma_pagamento.id;
        return (
          this.currentQuotation.forma_pagamento.id +
          "x R$ " +
          asNumberString(valor)
        );
      }
      if (item.forma_pagamento.id == 1) {
        return "À vista";
      }
      return item.forma_pagamento.id + " parcelas";
    }
  },
  props: {
    currentQuotation: {
      type: Object
    },
    isTableView: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="sass" scoped>
.dados-proponente-table
  font-size: 12px
  min-width: 100%
  border-spacing: 14px 6px
  tr
    text-align: left
    th
      font-weight: 500
    td
      background-color: #f7f7f7
      border-bottom:  2px solid #727272
      font-weight: 500
.seguro-agricola-table
  font-size: 12px
  min-width: 100%
  border-collapse: collapse
  tr
    text-align: left
    font-size: 12px
    th
      text-align: center
      background-color: #f2f2f2
      border: 1px solid black
      padding: 2px 4px
      font-weight: 400
    td
      text-align: center
      border: 1px solid black
      padding: 3px 6px
.section-title
  background-color: black
  color: white
  min-width: 100%
  min-height: 15px
  text-align: left
.info-section-title
  display: flex
  td
    background-color: #c00000
    color: white
    text-align: left
    width: 380px
.info-section-table
  font-size: 12px
  border-collapse: collapse
  border: 1px solid black
  min-width: 100%
  td
    min-width: 100%
    padding: 5px
.titleCard
  width: 1332px
.cards-containerAgricola
  display: flex
  flex-flow: row wrap
  margin: 0
  padding: 0
@media print
  .titleCard
    width: 980px
  .cards-containerAgricola
    display: flex
    flex-flow: row wrap
    margin-left: 0px !important
    padding: 0px !important
@media print
  .container-cardsAgricola
    margin: 0 !important
    padding: 5px !important
@media print
  .card-wrapperAgricola
    page-break-inside: avoid
    padding: 0
</style>
